<template>
	<div class="blackheadsguidedetail">
		<Loading msg="loading" v-if="!isload" />
		<div class="guide_inner" v-else>
      		<img @click="$parent.goBack()"
				v-lazy="'https://static.inertiabiotech.com/uniskin/reportv3/images/gene_test_back.png'"
				class="back_btn lazy"
				alt="" />
                <div class="inner_up">
                    <div class="guide_title"><h1>护理要点/</h1><span class="title_tip">根据您的特征定制化护肤</span></div>
                    <ul class="detail_menu">
                        <li class="menu_item" :class="focused_idx == title_idx ? 'now' : ''" @click="changeFocusedTab(title_idx);ing_relative_index=0;getTriangleLeft(0);" :ref="'focused_item_'+title_idx" v-for="(title_item,title_idx) in guidedata" :key="title_idx">{{title_item.name}}</li>
                        <!-- <li class="menu_item" :class="focused_idx == 1 ? 'now' : ''" @click="changeFocusedTab(1);" ref="focused_item_1">控油</li> -->
                        <!-- <li class="menu_item" :class="focused_idx == 2 ? 'now' : ''" @click="changeFocusedTab(2);" ref="focused_item_2">以油溶油</li> -->
                        <span class="bg_div" :style="'width:' + focused_width + 'px;left:' + focused_left + 'px'"></span>
                    </ul>
                </div>
                <!-- 深层清洁 -->
                <template v-for="(rec_item,rec_idx) in guidedata">
                <div class="inner_down inner_down_first" v-if="focused_idx == rec_idx" :key="rec_idx">
                <template v-for="(info_item,info_idx) in rec_item.info">
                    <div class="inner_down_rec_container" :key="info_idx">


                    <!-- 只有标题+建议 -->
                    <div class="inner_down_rec_title_text_only" style="padding-top:0.8rem;" v-if="(!info_item.ing) && (!info_item.products)">
                        <div class="inner_down_usage_title" v-if="info_item.title">{{info_item.title}}</div>
                            <p class="inner_down_usage_desc_text" v-html="info_item.suggest">每日使用洗面奶时,在鼻头部位打圈按摩,清除多余油脂,防止毛孔堵塞,预防黑头、粉刺.</p>
                    </div>

                    <!-- 没有成分信息  只有产品时   -->
                   
                    
                        <div class="inner_down_rec_without_ing" v-if="info_item.products">
                            <div class="inner_down_usage_title" v-if="info_item.title">{{info_item.title}}</div>
                            <p class="inner_down_usage_desc_text" v-html="info_item.suggest">每日使用洗面奶时,在鼻头部位打圈按摩,清除多余油脂,防止毛孔堵塞,预防黑头、粉刺.</p>
                            <div class="inner_down_rec_title">推荐产品</div>
                            <ul class="inner_rec_pro_list">
                                <li class="inner_rec_pro" v-for="(pro_item,pro_idx) in info_item.products" :key="pro_idx" @click="pro_item.go_mall && $parent.goMallDetail(pro_item.pro_id)">
                                    <div class="inner_rec_pro_check_btn" v-show="pro_item.go_mall">
                                        <span class="inner_rec_pro_check_text">去购买</span>
                                        <img src="../assets/images/arrow_right_d.svg" class="inner_rec_pro_check_icon" alt="">
                                    </div>
                                    
                                    <img :src="pro_item.url" :key="pro_item.url" class="pro_pic" alt="">
                                    <div class="pro_detail">
                                        <div class="pro_name">{{pro_item.pro_name}}</div>
                                        <div class="pro_ing"><span>功效:</span><span class="ing_item" v-for="(effect_item,effect_idx) in pro_item.effect" :key="effect_idx">{{effect_item}}</span></div>
                                        <div class="pro_price" v-html="pro_item.price"></div>
                                    </div>
                                </li>
                            </ul>
                        </div>



                        <!-- 有成分信息时 -->
                        <div class="inner_down_rec_with_ing" v-show="info_item.ing">
                            <div class="inner_down_usage_title" v-if="info_item.title">{{info_item.title}}</div>
                            <p class="inner_down_usage_desc_text" v-html="info_item.suggest">每日使用洗面奶时,在鼻头部位打圈按摩,清除多余油脂,防止毛孔堵塞,预防黑头、粉刺.</p>
                            <div class="ing_container_title">成分推荐</div>
                            <div class="ing_container" ref="ing_box">
                                <ul class="ing_list" ref="ing_list">
                                    <li class="ing" :class="ing_relative_index==ing_idx ? 'now' : ''" :ref="'ing_'+ing_idx" @click="($parent.trackLog((actParams = { query: $route.query, pageid:565 }),{is_access:true,reportEvent_page_id:565,reportEvent_page_name:'黑头-护理要点-成分',reportEvent_report_type:'199基因',reportEvent_first_module:'护肤方案',reportEvent_second_module:'皮肤问题',reportEvent_third_module:'黑头'}));getTriangleLeft(ing_idx);ing_relative_index=ing_idx;" v-for="(ing,ing_idx) in info_item.ing" :key="ing_idx"><img :src="ing.url" :key="ing.url" class="ing_pic" alt=""><div class="ing_name">{{ing.name}}</div></li>
                                </ul>
                            </div>
                            
                                <div class="ing_detail_outer">
                                    <template v-for="(ing_detail,ing_detail_idx) in info_item.ing">
                                        <div class="ing_detail" :key="ing_detail_idx" :class="ing_relative_index == ing_detail_idx ? 'now' : ''">
                                            <img src="../assets/images/triangle_icon.png" class="triangle_icon" ref="triangle_icon" :style="'left:'+triangle_left+'px'" alt="">
                                            <div class="ing_effect_name"><span>{{ing_detail.name}}</span></div>
                                            <div class="ing_effect_title">成分功效</div>
                                            <p class="ing_effect_text">{{ing_detail.effect}}</p>
                                            <div class="ing_pro_title">含有该成分的护肤品</div>
                                            <div class="ing_pro_related">
                                                <!-- 存在uniskin产品 -->
                                                <template v-for="(pro_item,pro_idx) in ing_detail.products">
                                                <div class="self_pro" v-show="pro_item.pro_name.includes('优时颜')" :key="pro_idx">
                                                    <img :src="pro_item.url" :key="pro_item.url" class="self_pic" alt="">
                                                    <div class="self_info">
                                                        <div class="self_name">{{pro_item.pro_name}}</div>
                                                        <div class="self_introduce" >{{pro_item.pro_name.includes('优时颜净能') ? '净能控油精萃乳是一款多通路干预皮脂生成，解决面部油光根源问题的产品，' : '基于护肤水即时舒缓、帮助后续产品吸收的功能特性，在开发平衡水时重点'}}
                                                        <div class="text_remaining" :class="text_remaining_show ? 'now' : ''" @click="text_remaining_show=!text_remaining_show" v-show="pro_item.pro_name.includes('优时颜净能')">相对于传统的添加矿物粉成分的控油功效产品，把控油的机理从“吸附”变为“作用”，即使是素颜状态，也可以让面部不泛油光，毛孔更加细腻。</div>
                                                        <div class="text_remaining" :class="text_remaining_show ? 'now' : ''" @click="text_remaining_show=!text_remaining_show" v-show="!(pro_item.pro_name.includes('优时颜净能'))">关注了它的吸收性、温和性和保湿性，而美白、抗皱等功能则需要通过后续精华产品来达到。</div>
                                                        </div>
                                                    </div>
                                                </div>
                                                </template>
                                                <!-- 非uniskin产品 -->
                                                <ul class="oth_pros" v-show="ing_detail.products">
                                                    <template v-for="(oth_pro,oth_idx) in ing_detail.products">
                                                    <li class="oth_pro" :key="oth_idx" v-show="!oth_pro.pro_name.includes('优时颜')"><img :src="oth_pro.url" :key="oth_pro.url" class="oth_pro_pic" alt=""><div class="oth_pro_name">{{oth_pro.pro_name}}</div></li>
                                                    </template>
                                            
                                                </ul>
                                            </div>

                                            <!-- 查看其他产品列表按钮 -->
                                            <div class="ing_pro_related_check"><span @click="($parent.trackLog((actParams = { query: $route.query, pageid:566 }),{is_access:true,reportEvent_page_id:566,reportEvent_page_name:'黑头-护理要点-产品列表',reportEvent_report_type:'199基因',reportEvent_first_module:'护肤方案',reportEvent_second_module:'皮肤问题',reportEvent_third_module:'黑头'}));checkOthPro(ing_detail.products)">查看产品详情</span></div>
                                        </div>
                                    </template>
                                </div>
                        </div>
                    </div>
                    
                </template>
                </div>
                </template>

      
        <!-- 其他产品列表弹窗 -->
        <transition name="fade">
            <div class="oth_rec_layer" v-if="show_oth_pro_list">
                <div class="layer_inner">
                    <img src="../assets/images/close_btn.svg" class="close_icon" alt="" @click="show_oth_pro_list =false">
                    <div class="layer_title">产品列表</div>
                    <ul class="layer_pro_list">
                    <li class="layer_pro" v-for="(oth_pro_item,oth_pro_idx) in check_oth_pro_list" :key="oth_pro_idx" @click="oth_pro_item.go_mall && $parent.goMallDetail(oth_pro_item.pro_id);">
                        <div class="layer_pro_check_btn" v-if="oth_pro_item.go_mall">
                            <span>去购买</span>
                            <img src="../assets/images/arrow_right_d.svg" class="layer_pro_check_icon" alt="" v-if="oth_pro_item.go_mall">
                        </div>
                        <!-- <img src="../assets/images/arrow_right_d.svg" class="layer_pro_check_icon" alt="" v-if="oth_pro_item.go_mall"> -->

                        <img :src="oth_pro_item.url" class="pro_pic" alt="">
                        <div class="pro_detail">
                            <div class="pro_name">{{oth_pro_item.pro_name}}</div>
                            <div class="pro_ing"><span>功效:</span><span class="ing_item" v-for="(effect,e_idx) in oth_pro_item.effect" :key="e_idx">{{effect}}</span></div>
                            <div class="pro_price" v-html="oth_pro_item.price"></div>
                        </div>
                    </li>
  
 
                    </ul>

                </div>
            </div>
        </transition>

		
		</div>

 
	</div>
</template>

<script>
import Loading from "./Loading.vue";
import axios from "axios";
import { setTimeout } from 'timers';
var wx = require("weixin-js-sdk");
export default {
  name: "BlackheadsGuideDetail",
  data() {
    return {
      isload: false,
      focused_idx:0,
      focused_left:0,
      focused_width:0,
      triangle_left:30,  //成分详情icon
      in_weapp: false, //是否在小程序
      guidedata:[],
      show_rec:true,  //早晚护肤列表
      show_oth:false,  //对应类型产品
      text_remaining_show:false,  
      ing_relative_index:0,  //成分对应展示index
      show_oth_pro_list:false,  //其他产品弹窗
      detail_tag_name:null,
      detail_tag_index:null,
      blackheads_guide_obj:{
          tag1:{  //以油溶油
            name:"以油溶油",
            info:[
                {
                    
                    suggest:"使用霍霍巴油、角鲨烷等油性成分，以油溶油，清除堵塞毛孔的油脂，是一种比较温和的方法。<br>正常肌肤一周一次，敏感性肌肤两周一次。需要坚持1~2个月才有效果。",
                    ing:[
                        {
                            name:"霍霍巴油",
                            url:"https://static.inertiabiotech.com/uniskin/reportv3/images/blackheads_ing_huohuoba.png",
                            effect:"溶解油脂，疏通毛孔",
                            products:[
                                {
                                    pro_name:"Florihana 霍霍巴油",
                                    url:"https://static.inertiabiotech.com/uniskin/reportv3/images/blackheads_Florihana.png",
                                    price:"参考价格:&yen;196/50ml",
                                    effect:["保湿","舒缓肌肤","柔润肌肤","活肤滋润"]
                                },
                                {
                                    pro_name:"言之有物 霍霍巴油",
                                    url:"https://static.inertiabiotech.com/uniskin/reportv3/images/blackheads_yanzhiyouwu_huohuoba.png",
                                    price:"参考价格:&yen;136/200ml",
                                    effect:["滋润","深层清洁","清洁毛孔"]
                                }
                            ]
                        },
                        {
                            name:"角鲨烷",
                            url:"https://static.inertiabiotech.com/uniskin/reportv3/images/blackheads_ing_jiaoshawan.png",
                            effect:"角鲨烷适合在寒冷干燥的冬季使用，有保湿、屏障修复的功能。使用少量角鲨烷按摩鼻头部位可以帮助疏通毛孔。",
                            products:[
                                {
                                    pro_name:"HABA 鲨烷精纯美容油",
                                    url:"https://static.inertiabiotech.com/uniskin/reportv3/images/blackheads_HABA.png",
                                    price:"参考价格:&yen;215/15g",
                                    effect:["提亮肤色","滋润","淡化暗斑","滋养肌肤"]
                                },
                                {
                                    pro_name:"彼得罗夫 角鲨烷植物精粹纯液",
                                    url:"https://static.inertiabiotech.com/uniskin/reportv3/images/blackheads_peter_ruff.png",
                                    price:"参考价格:&yen;350/30ml",
                                    effect:["补水","保湿","控油"]
                                }
                            ]
                        }
                    ]
                }
            ]
          },
          tag2:{  //深层清洁
            name:"深层清洁",
            info:[
                {
                    title:"日常清洁",
                    suggest:"每日使用洗面奶时，在鼻头部位打圈按摩，清除多余油脂，防止毛孔堵塞，预防黑头、粉刺。",
                    // ing:[
                        // {
                            // name:"",
                            // url:"",
                            // effect:"",
                            products:[
                                {
                                    pro_name:"芙丽芳丝净润洗面霜",
                                    url:"https://static.inertiabiotech.com/uniskin/reportv3/images/blackheads_free_plus.png",
                                    price:"参考价格:&yen;150/100g",
                                    effect:["深层清洁","滋润","清洁肌肤","保湿补水"]
                                },
                                {
                                    pro_name:"露得清深层净化活力洗面乳",
                                    url:"https://static.inertiabiotech.com/uniskin/reportv3/images/blackheads_neutrogena_cleanser.png",
                                    price:"参考价格:&yen;113.5/200g",
                                    effect:["深层清洁"]
                                },
                                {
                                    pro_name:"优时颜优能平衡洁面乳",
                                    url:"https://static.inertiabiotech.com/uniskin/reportv3/images/Cleanser.png",
                                    go_mall:true,
                                    pro_id:16,
                                    price:"会员价:&yen;95/100g",
                                    effect:["深层清洁","温和","补水","保湿"]
                                }
                            ]
                        // }
                    // ]
                },
                {
                    title:"使用膏状清洁面膜",
                    suggest:"在鼻头部位涂抹膏状清洁面膜，达到疏松毛孔、吸附油脂的深层清洁效果。<br>正常肌肤一周一次，敏感性肌肤两周一次。",
                    // ing:[
                        // {
                            // name:"",
                            // url:"",
                            // effect:"",
                            products:[
                                {
                                    pro_name:"科颜氏亚马逊白泥净致面膜",
                                    url:"https://static.inertiabiotech.com/uniskin/reportv3/images/blackheads_kiehls.png",
                                    price:"参考价格:&yen;290/125ml",
                                    effect:["平衡油脂分泌","活肤滋润","清洁肌肤"]
                                },
                                {
                                    pro_name:"悦诗风吟火山岩泥毛孔清洁多效面膜",
                                    url:"https://static.inertiabiotech.com/uniskin/reportv3/images/blackheads_innisfree_mask.png",
                                    price:"参考价格:&yen;109/100ml",
                                    effect:["清洁肌肤","控油","收缩毛孔","清洁毛孔"]
                                },
                                {
                                    pro_name:"理肤泉净肤祛油毛孔清洁面膜",
                                    url:"https://static.inertiabiotech.com/uniskin/reportv3/images/blackheads_la_roche_posay.png",
                                    price:"参考价格:&yen;185/100ml",
                                    effect:["控油","清洁毛孔"]
                                }
                            ]
                        // }
                    // ]
                }
            ]
          },
          tag3:{  //酸类剥脱
            name:"酸类剥脱",
            info:[
                {
                    title:"使用酸类产品",
                    suggest:"帮助加速老废角质的代谢，疏通毛孔，减少黑头。<br>正常肌肤一周2~3次，局部使用。需要坚持1~2个月才有效果。",
                    ing:[
                        {
                            name:"水杨酸",
                            url:"https://static.inertiabiotech.com/uniskin/reportv3/images/blackheads_ing_shuiyangsuan.png",
                            effect:"油溶性，加速角质细胞代谢，减少毛囊口堵塞",
                            products:[
                                {
                                    pro_name:"博乐达超分子水杨酸柔肤水",
                                    url:"https://static.inertiabiotech.com/uniskin/reportv3/images/blackheads_broda.png",
                                    price:"参考价格:&yen;398/30ml",
                                    effect:["修护","滋养","控油提亮肤色"]
                                },
                                {
                                    pro_name:"宝拉珍选2%水杨酸焕彩精华",
                                    url:"https://static.inertiabiotech.com/uniskin/reportv3/images/blackheads_polar_2.png",
                                    price:"参考价格:&yen;198/30ml",
                                    effect:["调理角质","控油","收缩毛孔","抗痘","祛痘"]
                                }

                            ]
                        },
                        {
                            name:"果酸",
                            url:"https://static.inertiabiotech.com/uniskin/reportv3/images/blackheads_ing_guosuan.png",
                            effect:"如羟基乙酸、乳酸、苹果酸等，加速废旧角质代谢，促进表皮更新，缩小毛孔",
                            products:[
                                {
                                    pro_name:"Martiderm夜间焕肤安瓶",
                                    url:"https://static.inertiabiotech.com/uniskin/reportv3/images/blackheads_Martiderm.png",
                                    price:"参考价格:&yen;199/10ml",
                                    effect:["调理角质","保湿","收缩毛孔","去黑头"]
                                },
                                {
                                    pro_name:"芯丝翠乳糖酸活性乳液",
                                    url:"https://static.inertiabiotech.com/uniskin/reportv3/images/blackheads_neostrata_lotion.png",
                                    price:"参考价格:&yen;429/100ml",
                                    effect:["保湿","滋润"]
                                },
                                {
                                    pro_name:"SESDERMA6%经典果酸精华",
                                    url:"https://static.inertiabiotech.com/uniskin/reportv3/images/blackheads_SESDERMA6.png",
                                    price:"参考价格:&yen;389/30ml",
                                    effect:["改善局部黯沉","改善黯沉","提亮肤色"]
                                },
                                {
                                    pro_name:"The ordinary 果酸焕肤精华",
                                    url:"https://static.inertiabiotech.com/uniskin/reportv3/images/blackheads_The_ordinary.png",
                                    price:"参考价格:&yen;199/30ml",
                                    effect:["提亮肤色","去黑头","去角质"]
                                }

                            ]
                        }
                    ]
                },
                {
                    title:"小气泡",
                    suggest:"利用真空负压原理吸住皮肤，把黑头吸出来，同时在真空回路里注入果酸或水杨酸溶液焕肤。<br>正常肌肤2~3周一次。即时效果较好，不过可能会有刺痛泛红的不良反应。",
                    // ing:[
     
                    // ]
                }
            ]
          },
          tag4:{  //控油1
            name:"控油",
            info:[
                {
                    title:"生活饮食",
                    suggest:"少吃糖，少喝含糖饮料，比如奶茶、可乐。少吃盐，不要吃盐含量太高的食物。<br>减轻自身压力，增加运动，调节工作节奏。",
                    // ing:[

                    // ]
                },
                {
                    title:"使用控油产品",
                    suggest:"减少油脂分泌，从源头减少黑头的产生。每日护肤时，在出油较多的部位使用。需要坚持1~2个月才有效果。",
                    ing:[
                        {
                            name:"烟酰胺",
                            url:"https://static.inertiabiotech.com/uniskin/reportv3/images/blackheads_ing_yanxianan.png",
                            effect:"临床试验显示，2%烟酰胺对控制油脂分泌有一定作用",
                            products:[
                                {
                                    pro_name:"OLAY5%烟酰胺小白瓶",
                                    url:"https://static.inertiabiotech.com/uniskin/reportv3/images/blackheads_Olay_5.png",
                                    price:"参考价格:&yen;280/30ml",
                                    effect:["改善黯沉","提亮肤色","保湿"]
                                },
                                {
                                    pro_name:"The ordinary 10%烟酰胺精华",
                                    url:"https://static.inertiabiotech.com/uniskin/reportv3/images/blackheads_The_ordinary_10.png",
                                    price:"参考价格:&yen;85/30ml",
                                    effect:["温和调理肌肤","控油","水油平衡"]
                                },
                                {
                                    pro_name:"SK-Ⅱ肌因光蕴环采钻白精华露（小灯泡）",
                                    url:"https://static.inertiabiotech.com/uniskin/reportv3/images/blackheads_SK_II.png",
                                    price:"参考价格:&yen;2080/60ml",
                                    effect:["提亮肤色","淡化暗斑","淡斑","修护"]
                                }
                            ]
                        },
                        {
                            name:"假交替单胞菌发酵产物提取物",
                            url:"https://static.inertiabiotech.com/uniskin/reportv3/images/blackheads_ing_jiajiaoti.png",
                            effect:"降低MC5-R（与皮脂腺细胞分化有关）的蛋白质水平，减少皮脂腺细胞的成熟及脂质过氧化，从而减少面部油光",
                            products:[
                                {
                                    pro_name:"优时颜净能控油精萃乳",
                                    go_mall:true,
                                    pro_id:19,
                                    url:"https://static.inertiabiotech.com/uniskin/reportv3/images/PIPAR_1.png",
                                    price:"会员价:&yen;180/30g",
                                    effect:["控油"]
                                }
                            ]
                        },
                        {
                            name:"PCA锌",
                            url:"https://static.inertiabiotech.com/uniskin/reportv3/images/blackheads_ing_pcazn.png",
                            effect:"降低皮肤中5α还原酶活性，调节皮脂腺分泌油脂",
                            products:[
                                {
                                    pro_name:"雅诗兰黛净莹细致化妆水",
                                    url:"https://static.inertiabiotech.com/uniskin/reportv3/images/blackheads_esteelauder_toner.png",
                                    price:"参考价格:&yen;250/200ml",
                                    effect:["补水","深层清洁"]
                                },
                                {
                                    pro_name:"ISDIN怡思丁控油净颜平衡日用乳",
                                    url:"https://static.inertiabiotech.com/uniskin/reportv3/images/blackheads_ISDIN.png",
                                    price:"参考价格:&yen;229/50ml",
                                    effect:["控油"]
                                },
                                {
                                    pro_name:"理肤泉清痘净肤焕肤精华乳K+",
                                    url:"https://static.inertiabiotech.com/uniskin/reportv3/images/blackheads_la_roche_posay_k.png",
                                    price:"参考价格:&yen;278/40ml",
                                    effect:["抗痘"]
                                }
                            ]
                        },
                        {
                            name:"榆绣线菊提取物",
                            url:"https://static.inertiabiotech.com/uniskin/reportv3/images/blackheads_ing_yuxiuxianju.png",
                            effect:"含有调理皮脂腺的多酚成分，有效调节皮脂腺的异常分泌，同时具有抑菌作用",
                            products:[
                                {
                                    pro_name:"薇诺娜毛孔收缩水",
                                    url:"https://static.inertiabiotech.com/uniskin/reportv3/images/blackheads_winona_toner.png",
                                    price:"参考价格:&yen;188/120ml",
                                    effect:["收缩毛孔"]
                                },
                                {
                                    pro_name:"优时颜净能控油精萃乳",
                                    go_mall:true,
                                    pro_id:19,
                                    url:"https://static.inertiabiotech.com/uniskin/reportv3/images/PIPAR_1.png",
                                    price:"会员价:&yen;180/30g",
                                    effect:["控油"]
                                }
                            ]
                        },
                        {
                            name:"维A及其衍生物",
                            url:"https://static.inertiabiotech.com/uniskin/reportv3/images/blackheads_ing_vayanshengwu.png",
                            effect:"抑制皮脂分泌；促进角质细胞代谢，减少毛囊口堵塞",
                            products:[
                                {
                                    pro_name:"露得清维A醇晚霜",
                                    url:"https://static.inertiabiotech.com/uniskin/reportv3/images/blackheads_neutrogena_night_cream.png",
                                    price:"参考价格:&yen;139/40g",
                                    effect:["增强皮肤弹性","改善皱纹","保湿"]
                                },
                                {
                                    pro_name:"Roc洛克维A醇抗皱精华",
                                    url:"https://static.inertiabiotech.com/uniskin/reportv3/images/blackheads_ROC.png",
                                    price:"参考价格:&yen;268/30ml",
                                    effect:["提亮肤色","损伤修复","抗衰老","保湿"]
                                },
                                {
                                    pro_name:"CeraVe维A醇精华",
                                    url:"https://static.inertiabiotech.com/uniskin/reportv3/images/blackheads_CeraVe.png",
                                    price:"参考价格:&yen;198/30ml",
                                    effect:["改善皱纹","提亮肤色"]
                                }
                            ]
                        },
                    ]
                }
            ]
          },
          tag5:{  //控油2
            name:"控油",
            info:[
                {
                    title:"生活饮食",
                    suggest:"少吃糖，少喝含糖饮料，比如奶茶、可乐。少吃盐，不要吃盐含量太高的食物。<br>减轻自身压力，增加运动，调节工作节奏。",
                    // ing:[

                    // ]
                },
                {
                    title:"使用控油产品",
                    suggest:"减少油脂分泌，从源头减少黑头的产生。每日护肤时，在出油较多的部位使用。需要坚持1~2个月才有效果。",
                    ing:[
                        {
                            name:"假交替单胞菌发酵产物提取物",
                            url:"https://static.inertiabiotech.com/uniskin/reportv3/images/blackheads_ing_jiajiaoti.png",
                            effect:"降低MC5-R（与皮脂腺细胞分化有关）的蛋白质水平，减少皮脂腺细胞的成熟及脂质过氧化，从而减少面部油光",
                            products:[
                                {
                                    pro_name:"优时颜净能控油精萃乳",
                                    go_mall:true,
                                    pro_id:19,
                                    url:"https://static.inertiabiotech.com/uniskin/reportv3/images/PIPAR_1.png",
                                    price:"会员价:&yen;180/30g",
                                    effect:["控油"]
                                }
                            ]
                        },
                        {
                            name:"PCA锌",
                            url:"https://static.inertiabiotech.com/uniskin/reportv3/images/blackheads_ing_pcazn.png",
                            effect:"降低皮肤中5α还原酶活性，调节皮脂腺分泌油脂",
                            products:[
                                {
                                    pro_name:"雅诗兰黛净莹细致化妆水",
                                    url:"https://static.inertiabiotech.com/uniskin/reportv3/images/blackheads_esteelauder_toner.png",
                                    price:"参考价格:&yen;250/200ml",
                                    effect:["补水","深层清洁"]
                                },
                                {
                                    pro_name:"ISDIN怡思丁控油净颜平衡日用乳",
                                    url:"https://static.inertiabiotech.com/uniskin/reportv3/images/blackheads_ISDIN.png",
                                    price:"参考价格:&yen;229/50ml",
                                    effect:["控油"]
                                },
                                {
                                    pro_name:"理肤泉清痘净肤焕肤精华乳K+",
                                    url:"https://static.inertiabiotech.com/uniskin/reportv3/images/blackheads_la_roche_posay_k.png",
                                    price:"参考价格:&yen;278/40ml",
                                    effect:["抗痘"]
                                }
                            ]
                        },
                        {
                            name:"榆绣线菊提取物",
                            url:"https://static.inertiabiotech.com/uniskin/reportv3/images/blackheads_ing_yuxiuxianju.png",
                            effect:"含有调理皮脂腺的多酚成分，有效调节皮脂腺的异常分泌，同时具有抑菌作用",
                            products:[
                                {
                                    pro_name:"薇诺娜毛孔收缩水",
                                    url:"https://static.inertiabiotech.com/uniskin/reportv3/images/blackheads_winona_toner.png",
                                    price:"参考价格:&yen;188/120ml",
                                    effect:["收缩毛孔"]
                                },
                                {
                                    pro_name:"优时颜净能控油精萃乳",
                                    go_mall:true,
                                    pro_id:19,
                                    url:"https://static.inertiabiotech.com/uniskin/reportv3/images/PIPAR_1.png",
                                    price:"会员价:&yen;180/30g",
                                    effect:["控油"]
                                }
                            ]
                        }
                    ]
                }
            ]
          }
      }
    };
  },

  created() {
    console.log("skincareguide created", this);
    this.detail_tag_name= this.$route.query.detail;
    this.detail_tag_index = this.$route.query.detail_index;
    this.focused_idx = this.$route.query.detail_index;
    console.log('detail_tag_name',this.detail_tag_name);
    console.log('detail_tag_index',this.detail_tag_index);
    this.initBlackheadsGuide();
  },
  mounted() {
        setTimeout(() => {
			this.changeFocusedTab(this.focused_idx);
		}, 500);
      
    var ua = navigator.userAgent.toLowerCase(),
      that = this;
    if (ua.match(/MicroMessenger/i) == "micromessenger") {
      wx.miniProgram.getEnv(res => {
        if (res.miniprogram) {
          console.log("在小程序里");
          that.in_weapp = true;
        }
      });
    }
  },
  methods: {
        checkOthPro:function(oths){
          this.check_oth_pro_list = oths;
          this.show_oth_pro_list = true;
      },
      getTriangleLeft:function(index){
          if(this.$refs['ing_'+index][0]){
            console.log(this.$refs);
            this.triangle_left = this.$refs['ing_'+index][0].offsetLeft - this.$refs['ing_box'][0].scrollLeft -10;
        // this.triangle_left = this.$refs['ing_box'].scrollLeft;
          }

        if(this.triangle_left < 30){
            this.triangle_left = 30;
        }
      },
        changeFocusedTab: function(idx) {
            let that = this;
			that.focused_idx = idx;
			console.log(271, that.$refs['focused_item_' + idx][0]);
			
            setTimeout(() => {
                that.focused_width = that.$refs['focused_item_' + idx][0].clientWidth;
			    that.focused_left = that.$refs['focused_item_' + idx][0].offsetLeft;
            })
		},
    goMallDetail: function(pid) {
      if (this.in_weapp) {
        wx.miniProgram.navigateTo({
          url: "/mall-detail/mall-detail?scene=" + pid
        });
      } else {
        location.href =
          "https://www.uniskin.com.cn/homepage/m/pro_detail.html?p=" + pid;
      }
    },
    initBlackheadsGuide: function() {
      let that = this;
      var local_blackheads_guide = JSON.parse(localStorage.getItem("local_blackheads_guide"));
      if (local_blackheads_guide) {
        afterBlackheadsGuide(local_blackheads_guide);
      } else {
        that
          .$jsonp(
            "https://www.uniskin.com.cn/reportv2/index/report199_ex1/getBlackHeadSolution"
          )
          .then(json => {
            console.log(json);
            afterBlackheadsGuide(json);
            // localStorage.setItem("local_blackheads_guide",JSON.stringify(json));
          })
          .catch(err => {
            console.log(err);
            localStorage.clear();
            location.href =
              "https://www.uniskin.com.cn/mall/member/account/login";
          });
      }
      function afterBlackheadsGuide(guidedata) {
        if (guidedata.code == 0) {
          that.isload = true;
          let guide_tags = guidedata.data.tags;
          if(guide_tags.includes("以油溶油")){
              that.guidedata.push(that.blackheads_guide_obj.tag1);
          }
          if(guide_tags.includes("深层清洁")){
              that.guidedata.push(that.blackheads_guide_obj.tag2);
          }
          if(guide_tags.includes("酸类剥脱")){
              that.guidedata.push(that.blackheads_guide_obj.tag3);
          }
          if(guide_tags.includes("控油(1)")){
              that.guidedata.push(that.blackheads_guide_obj.tag4);
          }
          if(guide_tags.includes("控油(2)")){
              that.guidedata.push(that.blackheads_guide_obj.tag5);
          }
            console.log('that.guidedata',that.guidedata);
         


        }
      }
    },
    displayIng: function(ing) {
      this.show_ing = true;
      this.ing_obj = ing;
    },

    initActionLog: function(m, pageid) {
      if (m && pageid)
        return axios.get("/mall/member/reportV2/actionlog", {
          params: { m, pageid }
        });
    }
  },
  components: {
    Loading
  }
};
</script>
<style lang="less" scoped>
@import "../styles/mixin.less";
@import "../styles/reset.less";
//查看其他产品列表
.oth_rec_layer{
    position:fixed;
    top:0;
    left:0;
    width:100%;
    height:100%;
    background:rgba(0,0,0,0.2);
    .layer_inner{
        position:absolute;
        top:50%;
        left:50%;
        transform:translate(-50%,-50%);
        width:690/50rem;
        height:1033/50rem;
        .border-radius(14/50rem);
        .shadow;
        background:@bg_c_l;
        box-sizing:border-box;
        padding:45/50rem 20/50rem 45/50rem 0;
        .close_icon{
            position:absolute;
            top:52/50rem;
            right:30/50rem;
            width:30/50rem;
            height:30/50rem;
        }
        .layer_title{
            padding:0 0 60/50rem 30/50rem;
            font-size:44/50rem;
            line-height:1em;
            font-weight:bold;
        }
    }
}
.layer_pro{
    .display_flex;
    .flex-wrap_nowrap;
    .justify-content_flex-justify;
    position:relative;
    .layer_pro_check_icon{
        position:absolute;
        right:0;
        top:35%;
        transform:translateY(-50%);
        width:27/50rem;
        height:27/50rem;
    }
    .layer_pro_check_btn{
        position:absolute;
        right:0;
        top:35%;
        transform:translateY(-50%);
        width:14/50rem;
        height:27/50rem;
        .display_flex;
        .flex-wrap_nowrap;
        .justify-content_flex-end;
        span{
            .align-self_center;
            font-size:24/50rem;
            line-height:1em;
            color:@font-c-detail;
            padding-right:30/50rem;
            white-space:nowrap;
        }
        img{
            .align-self_center;
            width:27/50rem;
            height:27/50rem;
        }
    }
    .pro_pic,.pro_detail{
        .align-self_flex-start;
    }
    .pro_pic{
        width:163/50rem;
    }
    .pro_detail{
        padding:16/50rem 50/50rem 55/50rem 0;
        margin-bottom:29/50rem;
        width:494/50rem;
        border-bottom:1px solid @font-c-detail;
        .pro_name{
            font-size:30/50rem;
            line-height:1em;
            color:@font-c-3;
            padding-bottom:23/50rem;
        }
        .pro_ing{
            .display_flex;
            .justify-content_flex-start;
            .flex-wrap_wrap;
            span{
                .flex_0;
                font-size:24/50rem;
                line-height:1.1em;
                color:@font-c-9;
                &.ing_item{
                    padding-right:20/50rem;
                }
            }
            
        }
        .pro_price{
            padding-top:16/50rem;
            font-size:24/50rem;
            line-height:1em;
            color:@font-c-9;
        }
    }
}
.layer_pro_list{
    height:863/50rem;
    -webkit-overflow-y:scroll;
    overflow-y:scroll;
    box-sizing:border-box;
}
.layer_pro_list .layer_pro:last-child{
    .pro_detail{
        border-bottom:1px solid transparent;
    }
}
//有成分信息时
    .ing_container_title{
        padding-top:47/50rem;
        font-size:34/50rem;
        line-height:1em;
        font-weight:bold;
        color:@font-c-3;
    }
    .ing_container{
    padding:30/50rem 0 55/50rem;
    width:100%;
    -webkit-overflow-x:scroll;
    overflow-x:scroll;
    &::-webkit-scrollbar{
        display:none;
    }
    .ing_list{
        .display_flex;
        .flex-wrap_nowrap;
        .justify-content_flex-start;
        &::after{
            content:"";
            display:block;
            opacity:0;
            width:1px;
            height:1px;
            .flex_0;
        }
        .ing{
            .flex_0;
            margin-right:20/50rem;
            box-sizing:border-box;
            padding:0 0 23/50rem;
            .border-radius(14/50rem);
            .shadow;
            background:@font-c-f;
            width:180/50rem;
            height:180/50rem;
            &.now{
                background:#FFE4E4;
            }
            .ing_pic{
                width:100%;
            }
            .ing_name{
                padding:0 30/50rem;
                text-align:center;
                overflow:hidden;
                text-overflow:ellipsis;
                white-space:nowrap;
                font-size:24/50rem;
                // line-height:1em;
                color:@font-c-3;
            }
        }
    }
}
.ing_detail_outer{
    padding-right:30/50rem;
    .ing_detail{
        display:none;
        position:relative;
        .border-radius(14/50rem);
        .shadow;
        background:@bg_c_l;
        padding:40/50rem 30/50rem 48/50rem;
        .triangle_icon{
            position:absolute;
            width:60/50rem;
            height:20/50rem;
            top:-20/50rem;
            left:70/50rem;
        }
        .ing_effect_title{
            font-size:30/50rem;
            line-height:1em;
            color:@font-c-detail;
        }
        .ing_effect_name{
            padding-bottom:30/50rem;
            .display_flex;
            .flex-wrap_nowrap;
            .justify-content_flex-start;
            span{
                .flex_0;
                font-size:30/50rem;
                line-height:1.1em;
                font-weight:bold;
                color:@font-c-3;
                border-bottom:1px solid @font-c-3;
            }
        }
        .ing_effect_text{
            padding:9/50rem 0 41/50rem;
            font-size:24/50rem;
            line-height:30/50rem;
            color:@font-c-6;
        }
        .ing_pro_title{
            padding-bottom:30/50rem;
            font-size:30/50rem;
            line-height:1em;
            color:@font-c-detail;
        }
        &.now{
            display:block;
        }
    }
}
.ing_pro_related{
    background:@font-c-f;
    .shadow;
    .border-radius(14/50rem);
    padding:28/50rem 25/50rem 58/50rem;
}
.ing_pro_related_check{
    padding-top:25/50rem;
    .display_flex;
    .flex-wrap_nowrap;
    .justify-content_flex-end;
    span{
        .flex_0;
        font-size:26/50rem;
        line-height:1em;
        color:@font-c-detail;
        border-bottom:1px solid @font-c-detail;
    }
}
.self_pro{
    .display_flex;
    .flex-wrap_nowrap;
    .justify-content_flex-justify;
    border-bottom:1px solid @font-c-detail;
    padding-bottom:40/50rem;
    .self_pic{
        width:163/50rem;
        height:163/50rem;
    }
    .self_info{
        padding-top:11/50rem;
        .self_name{
            font-size:30/50rem;
            line-height:1em;
            color:@font-c-3;
            padding-bottom:16/50rem;
        }
        .self_introduce{
            font-size:24/50rem;
            line-height:30/50rem;
            color:@font-c-9;
            .text_remaining{
                position:relative;
                padding-bottom:40/50rem;
                font-size:24/50rem;
                line-height:30/50rem;
                color:@font-c-9;
                width:411/50rem;
                overflow:hidden;
                white-space:nowrap;
                text-overflow:ellipsis;
                &::after{
                    content:"展开";
                    display:block;
                    position:absolute;
                    right:0;
                    bottom:0/50rem;
                    font-size:24/50rem;
                    line-height:30/50rem;
                    color:@font-c-detail;
                }
                &.now{
                    overflow:unset;
                    white-space:unset;
                    text-overflow:unset;
                        &::after{
                        content:"收起";
                        display:block;
                        position:absolute;
                        right:0;
                        bottom:0/50rem;
                        font-size:24/50rem;
                        line-height:30/50rem;
                        color:@font-c-detail;
                    }
                }
            }
        }
    }
}
.oth_pros{
    .display_flex;
    .justify-content_flex-start;
    -webkit-overflow-x:scroll;
    overflow-x:scroll;
    .oth_pro{
        padding-top:30/50rem;
        margin-right:30/50rem;
        .oth_pro_pic{
            width:150/50rem;
            height:150/50rem;
            .border-radius(50%);
            .shadow;
            background:#efefef;
        }
        .oth_pro_name{
            text-align:center;
            font-size:24/50rem;
            line-height:1em;
            color:@font-c-3;
            padding-top:15/50rem;
            width:150/50rem;
            overflow:hidden;
            white-space:nowrap;
            text-overflow:ellipsis;
        }
    }
    &::after{
        content:"";
        display:block;
        opacity:0;
        width:5px;
        height:1px;
        .flex_0;
    }
}

.guide_inner{
    background:@bg_c_m;
    padding:0 0 169/50rem;
}
.back_btn{
    position:fixed;
    top:0.6rem;
    left:0;
    width:2.36rem;
    height:1.08rem;
    z-index:888;
}
.inner_up{
    padding:106/50rem 30/50rem 0;
    background:@font-c-f;
    .shadow;
    .guide_title{
        padding-bottom:80/50rem;
        .display_flex;
        .flex-wrap_nowrap;
        .justify-content_flex-start;
        h1,.title_tip{
            .align-self_flex-end;
        }
        h1{
            font-size:44/50rem;
            font-weight:bold;
            line-height:1em;
            margin-right:17/50rem;
            color:@font-c-3;
        }
        .title_tip{
            font-size:30/50rem;
            line-height:1em;
            color:@font-c-detail;
        }
    }
    .detail_menu {
    position:relative;
    box-sizing: border-box;
    // .shadow;
    // padding: 81/50rem 30/50rem 0/50rem;
    .display_flex;
    .flex-wrap_nowrap;
    .justify-content_flex-start;
    .menu_item {
    -webkit-tap-highlight-color:transparent; 
      padding-bottom: 10/50rem;
      margin-right:50/50rem;
      .align-items_flex-end;
      .flex_0;
    //   width: 33.33%;
      font-size: 30/50rem;
      line-height: 1em;
      text-align: center;
      color: @font-c-detail;
      border-bottom: 3px solid transparent;
      &.now {
        font-size: 34/50rem;
        font-weight: bold;
        color:@font-c-detail;
        
      }
    }
  }
    .bg_div{
    position:absolute;
    bottom:0;
    height:3px;
    width:1/50rem;
    background:#f099a6;
    -webkit-transition:left 0.5s;
    transition:left 0.5s;
    }
}
.inner_down{
    padding:59/50rem 30/50rem 80/50rem;
}

.inner_down{
  .inner_down_usage_title{
    font-size:30/50rem;
    line-height:1em;
    color:@font-c-detail;
  }
  .inner_down_usage_desc_text{
    padding:16/50rem 0 32/50rem;
    font-size:24/50rem;
    line-height:30/50rem;
    color:@font-c-6;
  }
  .inner_down_rec_title{
    padding-bottom:30/50rem;
    font-size:28/50rem;
    font-weight:bold;
    line-height:1em;
    color:@font-c-3;
  }
  .inner_rec_pro{
    .display_flex;
    .flex-wrap_nowrap;
    .justify-content_flex-justify;
    position:relative;
    .inner_rec_pro_check_btn{
        position:absolute;
        right:0;
        top:50%;
        transform:translateY(-50%);
        // width:27/50rem;
        // height:27/50rem;
        .display_flex;
        .flex-wrap_nowrap;
        .justify-content_flex-end;
        span{
            font-size:24/50rem;
            white-space:nowrap;
            line-height:1em;
            color:#f99d9b;
            .align-self_center;
        }
        .inner_rec_pro_check_icon{
            margin-left:10/50rem;
            width:27/50rem;
            height:27/50rem;
            .align-self_center;
        }
    }
    .pro_pic,.pro_detail{
        .align-self_center;
    }
    .pro_pic{
        width:163/50rem;
    }
    .pro_detail{
        padding:51/50rem 50/50rem 44/50rem 0;
        // margin-bottom:29/50rem;
        width:494/50rem;
        border-bottom:1px solid @font-c-detail;
        .pro_name{
            font-size:30/50rem;
            line-height:1em;
            color:@font-c-3;
            padding-bottom:23/50rem;
        }
        .pro_ing{
            .display_flex;
            .justify-content_flex-start;
            .flex-wrap_wrap;
            span{
                .flex_0;
                font-size:24/50rem;
                line-height:1.1em;
                color:@font-c-9;
                &.ing_item{
                    padding-right:20/50rem;
                }
            }
            
        }
        .pro_price{
            padding-top:16/50rem;
            font-size:24/50rem;
            line-height:1em;
            color:@font-c-9;
        }
    }
}
.inner_rec_pro_list{
  box-sizing:border-box;
  margin-bottom:87/50rem;
  padding-right:20/50rem;
   background:@bg_c_l;
   .border-radius(14/50rem);
   .shadow;
}
.inner_rec_pro_list .inner_rec_pro:last-child{
    .pro_detail{
        border-bottom:1px solid transparent;
    }
}
}
.inner_down_second{

}
.inner_down_third{

}

</style>
